module.exports = __webpack_public_path__ + "img/mle-logo-light.b2589576.png";